<h2 mat-dialog-title>{{ 'genericTree.dialog.assignMetadataByLevel' | transloco }}</h2>

<mat-dialog-content>
  @if (isLoading()) {
    <div class="loading-overlay">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  }

  <div class="level-selection" [class.disabled-content]="isLoading()">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'genericTree.level' | transloco }}</mat-label>
      <mat-select [value]="selectedLevel()" (selectionChange)="selectedLevel.set($event.value)" [disabled]="isLoading()">
        @for (level of levels(); track level) {
          <mat-option [value]="level" (mouseenter)="onLevelHover(level)" (mouseleave)="onLevelBlur()">
            {{ 'genericTree.level' | transloco }} {{ level }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="metadata-selection-list" [class.disabled]="!selectedLevel() || isLoading()">
    @for (meta of allMetadata(); track meta.id) {
      <div class="metadata-item"
           [class.selected]="isActive(meta)"
           (click)="!isLoading() && toggleMetadata(meta)"
           (keyup.enter)="!isLoading() && toggleMetadata(meta)"
           [attr.tabindex]="selectedLevel() && !isLoading() ? 0 : -1"
           [attr.aria-disabled]="!selectedLevel() || isLoading()"
           role="button">
        {{ meta.name }}
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="isLoading()">{{ 'genericTree.action.cancel' | transloco }}</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!selectedLevel() || isLoading()">
    {{ 'genericTree.action.save' | transloco }}
  </button>
</mat-dialog-actions>
